import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { initAllTemplateScripts, initScrollClass, initPreloader } from './utils/templateScripts'
import templatePlugin from './plugins/templatePlugin'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/override.scss'
import './assets/css/personalizar-hooks.scss'

//import './assets/css/main.css'
// Nota: o antigo sistema de variáveis --dark-*/--light-* (variables.css,
// main-dark.scss, main-light.scss) foi removido - nunca chegou a ser
// finalizado/ativado (estes imports já estavam comentados). O tema
// escuro/claro real do site é aplicado via ThemeSwitcher.vue, que troca
// dinamicamente entre css/main.css e css/main-light.css (arquivos CSS
// compilados estáticos em public/css/, geridos hoje pela tela
// Configurações > Personalizar do Gerenciador de Produtos).

import api from './api'
import util from './util'

// Define as propriedades globais ANTES de criar a instância Vue
Vue.prototype.$api = api
Vue.prototype.$util = util

import Logo from './components/Logo.vue'
import Product from './components/Product.vue'
import Carroussel from './components/Carroussel.vue'
import Carroussel2 from './components/Carroussel2.vue'
import Carroussel3 from './components/Carroussel3.vue'
import Stars from './components/Stars.vue'
import AccountMenu from './components/AccountMenu.vue'
import Pedido from './components/Pedido.vue'

import CarrouselParceiros from './components/CarrouselParceiros.vue'
import CategoriasSite from './components/CategoriasSite.vue'

//global components
Vue.component('mx3-logo', Logo)
Vue.component('Product', Product)
Vue.component('Carroussel', Carroussel)
Vue.component('Carroussel2', Carroussel2)
Vue.component('Carroussel3', Carroussel3)
Vue.component('CarrouselParceiros', CarrouselParceiros)
Vue.component('Stars', Stars)
Vue.component('AccountMenu', AccountMenu)
Vue.component('Pedido', Pedido)
Vue.component('CategoriasSite', CategoriasSite)

//settins
Vue.use(templatePlugin)
Vue.use(BootstrapVue)// Import Bootstrap and BootstrapVue CSS files (order is important)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

// Função para carregar scripts externos dinamicamente
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

// Função para inicializar os scripts após o carregamento
function initializeScripts() {
  // Aguarda um pouco para garantir que o DOM está pronto
  setTimeout(() => {
    // Inicializa todas as funcionalidades do template
    initAllTemplateScripts()
    initScrollClass()
    initPreloader()
  }, 100)
}

// Carrega os scripts necessários
async function loadVendorScripts() {
  try {
    // Lista de scripts para carregar
    const scripts = [
      '/assets/vendor/bootstrap/js/bootstrap.bundle.min.js',
      '/assets/vendor/aos/aos.js',
      '/assets/vendor/glightbox/js/glightbox.min.js',
      '/assets/vendor/drift-zoom/Drift.min.js',
      '/assets/vendor/purecounter/purecounter_vanilla.js'
    ]

    // Carrega todos os scripts em paralelo
    await Promise.all(scripts.map(script => loadScript(script)))

    // Inicializa os scripts após o carregamento
    initializeScripts()
  } catch (error) {
    console.error('Erro ao carregar scripts:', error)
  }
}


try {
  util.loadAllImages(() => {
  });
} catch (error) {
  console.log(error);
}

// Cria a instância do Vue
const app = new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    // Carrega os scripts após o Vue estar montado
    loadVendorScripts()
  }
}).$mount('#app')

// Exporta a instância do app para uso global se necessário
window.app = app
